import TransactionConfirmationModal, { ConfirmationModalContent } from 'components/TransactionConfirmationModal'
// import Web3Status from 'components/Web3Status'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import { useMICCOntract, useTokenContract } from 'hooks/useContract'
import { useCallback, useEffect, useState } from 'react'
import SweetAlert2 from 'react-sweetalert2'
import { useWalletModalToggle } from 'state/application/hooks'
import { useNativeCurrencyBalances } from 'state/wallet/hooks'

export default function Buy() {
  // function useGovernanceBravoContract(): Contract | null {
  //   return useContract(GOVERNANCE_BRAVO_ADDRESSES, GOVERNOR_BRAVO_ABI, true)
  // }
  const { account, chainId, library } = useActiveWeb3React()
  const [error, setError] = useState<any>()
  const [swalProps, setSwalProps] = useState({})
  const [showConfirm, setShowConfirm] = useState(false)
  const [attemptingTxn, setAttemptingTxn] = useState(false)
  const [loading, setLoading] = useState(false)
  const [state, setState] = useState(0)
  const toggleWalletModal = useWalletModalToggle()
  const userEthBalance = useNativeCurrencyBalances(account ? [account] : [])?.[account ?? '']

  const [txnHash, setTxnHash] = useState<string | undefined>()
  // const addTransaction = useTransactionAdder()

  const [success, setSuccess] = useState<boolean | undefined>()

  // const { price, setPrice } = useState(0.95)

  const contract = useMICCOntract(true)
  const micTokenContract = useTokenContract('0x7A3a87E1aD0Be9EbeCAE78D1B96E74fD359A1F72', true)

  const buyMIC = async () => {
    if (account) {
      // console.log(myRef)
      const balance = userEthBalance?.toSignificant(3)
      // console.log(balance)
      setSwalProps({})

      if (Number(balance) > 0.125) {
        try {
          // check if user has referral in contract

          // setShowConfirm(true)

          const check = await micTokenContract?.balanceOf(account)
          if (check) {
            if (Number(check) / 10 ** 18 > 0) {
              setSwalProps({})
              setSwalProps({
                show: true,
                title: 'Error',
                text: 'This wallet has already received MIC tokens',
                icon: 'error',
                // background,
              })
              return
            }
          }

          const options = { value: '125000000000000000' }

          setLoading(true)
          setState(1)
          let myRef = '0x0000000000000000000000000000000000000001'
          if (localStorage.getItem('micreferral') !== null) {
            myRef = localStorage.getItem('micreferral') || '0x0000000000000000000000000000000000000001'
          }

          setAttemptingTxn(true)

          const trans = await contract?.purchaseMICToken(myRef, options)

          if (trans) {
            setState(2)
          }
          const tx = await trans.wait()

          setState(3)
          if (tx) {
            setSwalProps({})
            setSwalProps({
              show: true,
              title: 'success',
              text: 'Transaction completed successfully',
              icon: 'success',
              // background,
            })
            setLoading(false)
          }
        } catch (error) {
          let reason: string | undefined
          while (Boolean(error)) {
            reason = error.reason ?? error.message ?? reason
            error = error.error ?? error.data?.originalError
          }
          // console.log(reason)
          // setError(reason)
          setSwalProps({})
          setSwalProps({
            show: true,
            title: 'Error',
            text: 'An error performing the transaction ',
            icon: 'error',
            // background,
          })
          setLoading(false)
        }
      } else {
        setSwalProps({})
        setSwalProps({
          show: true,
          title: 'Error',
          text: 'You have insufficient balance. you need at least 0.125 ETH ',
          icon: 'error',
          // background,
        })
      }
    }
  }

  const loadData = () => {
    try {
      if (!localStorage.getItem('mictoken')) {
        localStorage.setItem('mictoken', 'added')
        addToken({ address: micTokenContract?.address, symbol: 'MIC Token' })
      }
      // const price = contract?.getMicEthPrice()
      // setPrice(Number(price) / 10 ** 18)
    } catch {
      // setPrice(0.95)
    }
  }

  useEffect(() => {
    loadData()
  }, [])
  // 0x3968b60F6afAb609A1F4d0c0E13F86584C79c992 vault
  //1000000000000000 price
  // 25000000000000000000000
  const handleDismissConfirmation = useCallback(() => {
    setShowConfirm(false)
    // if there was a tx hash, we want to clear the input
    if (txnHash) {
      onPercentSelectForSlider(0)
    }
    setAttemptingTxn(false)
    setTxnHash('')
  }, [onPercentSelectForSlider, txnHash])

  const pendingText = <div>Buying 1 MIC token for 0.125 ETH</div>

  function modalHeader() {
    return <div style={{ padding: '16px' }}>Status</div>
  }

  const addToken = useCallback(
    (tokendetails) => {
      if (library && library?.provider?.isMetaMask && library.provider.request) {
        library.provider
          .request({
            method: 'wallet_watchAsset',
            params: {
              //@ts-ignore // need this for incorrect ethers provider type
              type: 'ERC20',
              options: {
                address: tokendetails.address,
                symbol: tokendetails.symbol,
                decimals: 18,
                image: 'logoURL',
              },
            },
          })
          .then((success) => {
            setSuccess(success)
          })
          .catch(() => setSuccess(false))
      } else {
        setSuccess(false)
      }
    },
    [library]
  )

  return (
    <>
      <section className="buy-sec flex-wrap flex-row d-flex align-content-center justify-content-center" id="feature">
        <div className="container">
          <SweetAlert2 {...swalProps} />
          <TransactionConfirmationModal
            isOpen={showConfirm}
            onDismiss={handleDismissConfirmation}
            attemptingTxn={attemptingTxn}
            hash={txnHash ?? ''}
            content={() => (
              <ConfirmationModalContent
                title="Buy MIC TOKEN"
                onDismiss={handleDismissConfirmation}
                topContent={modalHeader}
              />
            )}
            pendingText={pendingText}
          />
          <div className="row justify-content-center">
            <div className="col-lg-5 col-sm-8">
              <div className="buy-card">
                <div className="card-header border-0 pb-0 justify-content-between">
                  <h1>BUY MIC MINT TOKEN</h1>
                </div>
                <div className="card-body">
                  <div className="mic-round d-flex justify-content-between align-items-center">
                    <span className="text-white valign">
                      <img className="coin-select" src="img/eth-icon.png" /> ETH
                    </span>
                    <input type="text" className="mic-form" placeholder="0.0" maxLength={25} value={0.125} />
                  </div>
                  <div className="mic-round d-flex justify-content-between align-items-center">
                    <span className="text-white valign">
                      <img className="coin-select" src="img/mic-icon.png" /> MIC
                    </span>
                    <input type="text" className="mic-form" placeholder="0.0" value={1} maxLength={25} />
                  </div>
                  <p className="text-white">1 MIC TOKEN PER WALLET</p>
                  <div className="w-100">
                    {account ? (
                      <button onClick={() => buyMIC()} className="btn">
                        {loading ? 'SUBMITTING TRANSACTION' : 'BUY MIC'}
                      </button>
                    ) : (
                      <button className="btn" onClick={toggleWalletModal}>
                        Connect
                      </button>
                    )}
                  </div>
                  <div id="accordion">
                    <div
                      className="text-white collapsed"
                      data-toggle="collapse"
                      data-target="#collapseOne"
                      aria-expanded="false"
                      aria-controls="collapseOne"
                    >
                      0.125 BNB = 1 MIC
                      <span style={{ color: '#6c757d' }}> </span>
                      <span className="float-right dropdown-toggle pull-right"> Legacy</span>
                    </div>
                    <div
                      id="collapseOne"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingOne"
                      data-parent="#accordion"
                    >
                      <div className="d-flex justify-content-between pt-3">
                        <div className="text-white">Price: </div>
                        <div className="text-white"> 0.125 ETH</div>
                      </div>

                      <div className="d-flex justify-content-between">
                        <div className="text-white">Receiving: </div>
                        <div className="text-white float-right"> 1 MIC</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
function onPercentSelectForSlider(arg0: number) {
  throw new Error('Function not implemented.')
}
